import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeHtml',
  standalone: true,
})
export class DecodeHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null) return '';
    if (typeof value !== 'string') value = String(value);

    // Fallback for non-browser environments
    if (typeof document === 'undefined') {
      return value.replace(/&amp;/g, '&');
    }

    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    // textarea.value decodes HTML entities
    return textarea.value;
  }
}
